export default __webpack_public_path__ + "static/media/logo.f6fad2b1.png";